import styled from 'styled-components'
const baseImageUrl = process.env.BASE_IMAGES_URL


export default styled.div<{ isMobileCheck?: boolean }>`
	background-color: #f9f9f9;
	padding: 34px 0;
	.main {
		&__container {
			width: 100%;
			.header {
				color: #001744;
				padding-bottom: 24px;
				&__title {
					font-weight: 700;
					font-size: 40px;
					line-height: 48px;
					margin: 0;
					margin-bottom: 8px;
				}
				&__des {
					font-weight: 500;
					font-size: 14px;
					line-height: 17px;
					margin: 0;
				}
			}
			.result {
				width: 100%;
				background: #ffffff;
				border-radius: 6px;
				padding: 32px;
				&__count {
					display: flex;
					align-items: center;
					gap: 5px;
					font-weight: 700;
					font-size: 14px;
					line-height: 17px;
					margin-bottom: 16px;
					&-number {
						color: #ff7d55;
					}
				}
				&__wrap {
					display: flex;
					flex-direction: column;
					gap: 8px;
				}
			}
		}
	}
	@media all and (max-width: 992px) {
		padding: 12px 0;
		.main {
			padding: 0;
			&__container {
				.header {
					padding: 0 12px;
					&__title {
						font-size: 32px;
						margin: 0;
					}
				}
				.result {
					border-radius: 0px;
					margin: 20px 0;
					&__count {
						padding: 0 10px;
					}
				}
			}
		}
	}
	@media all and (max-width: 767px) {
		.main {
			&__container {
				padding-right: 0;
				padding-left: 0;
				& > .result {
					padding-left: 12px;
					padding-right: 12px;
					margin-top: 12px;
					&__wrap {
						padding: 0 12px;
					}
				}
			}
		}
	}
	/* @media all and (min-width: 768px) and (max-width: 991px) {
		padding: 12px 0;
		.main {
		}
	} */
	/* @media all and (min-width: 1400px) {
		.main {
		}
	}
	*/
	.vnwLayout__container {
		padding: ${({ isMobileCheck }) => isMobileCheck && '0 16px'};
	}

	.reco-container {
		
		.result-v7 {
			border-radius: 0 0 16px 16px;
			margin-top: 0 !important;
		}
		.result-mobile {
			padding: 0;
			background: transparent;
		}

		.reco-title-mobile {
			color: #333;
			font-size: 20px;
			font-weight: 600;
			line-height: 24px;
			margin-bottom: 16px;
		}

		.reco-header {
			background-color: black;
			overflow: hidden;
			border-radius: 16px 16px 0 0;
			position: relative;
			z-index: 0;
			background: black;
			&::before {
				content: '';
				position: absolute;
				top: 0;
				right: 0px;
				width: 256px;
				height: 250px;
				background-image: url(${`${baseImageUrl}/images/background-recommend-mobile.png`});
				background-size: cover;
				background-position: right;
				background-repeat: no-repeat;
				z-index: -1;
			}
			&__title {
				color: white;
				font-size: 32px;
				font-weight: 600;
				line-height: 40px;
				padding: 24px 32px;
			}
		}
	}
`
